// extracted by mini-css-extract-plugin
module.exports = {"section":"Hero-module--section--2RjqO","title":"Hero-module--title--1GJTp","image":"Hero-module--image--1eWpt","button":"Hero-module--button--27OwU"};